/** Simular operações sobre o modelo, sem tocar em nada: aplica os lotes
 *  que já estão pendentes (para partir do estado em que o ficheiro vai
 *  estar) e depois as novas, e devolve só o relatório das novas. */

import { aplicarOperacoes, type Lote, type Operacao, type Relatorio } from '@modules/ifc-edit/lib/operacoesEmMassa'
import { copiaEditavel } from './modeloEmTexto'

export function simular(modelId: string, pendentes: Lote[], novas: Operacao[]): Relatorio | null {
  const m = copiaEditavel(modelId)
  if (!m) return null
  const antes = pendentes.flatMap((l) => l.operacoes)
  if (antes.length > 0) aplicarOperacoes(m, antes)
  return aplicarOperacoes(m, novas)
}

const PORQUE: Record<string, string> = {
  cabecalho: 'escrito no cabeçalho',
  existente: 'o que a propriedade já tinha',
  modelo: 'o único que o modelo usa para ela',
  omissao: 'por omissão (texto)',
  enumeracao: 'o da enumeração de valores permitidos',
}

export function explicarPorque(p: string): string {
  return PORQUE[p] ?? p
}

export function novoIdDeLote(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`
}

export function agora(): string {
  return new Date().toISOString()
}
